<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary bg="/images/sub/about/visual.jpg">
                <template #title>{{ $t("회사소개") }}</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first">
            <template #subtit>about</template>
            <template #tit>{{ $t("개요") }}</template>

            <u-tit-wrap-default class="tit-wrap--sm">
                <u-tit-default class="tit--sm line-height-15">
                    <span v-html="$t('company.tit')" />
                </u-tit-default>
            </u-tit-wrap-default>

            <txt-primary>{{ $t("company.txt") }}</txt-primary>
            <v-img src="/images/sub/about/about.jpg" class="mt-40px mt-md-50px mt-lg-60px rounded-lg" />
        </page-section-primary>

        <page-section-primary titWrapClass="text-center" class="page-section--last page-section--vision">
            <template #subtit>vision</template>
            <template #tit><span class="white--text">{{ $t("비전") }}</span></template>

            <v-row class="row--lg">
                <v-col cols="12" md="6">
                    <v-card color="white" class="pa-20px pa-md-30px pa-lg-40px">
                        <div class="num-wrap">
                            <u-tit-default class="tit--sm">01</u-tit-default>
                        </div>
                        <v-divider class="w-20px w-lg-30px my-18px my-lg-24px mx-auto" />
                        <txt-primary class="txt--lg text-center">
                            <p class="font-weight-extrabold grey--text text--darken-4">{{ $t("vision.num01") }}</p>
                            <p class="mt-12px mt-lg-16px">
                                <span v-html="$t('vision.num01Txt')" />
                            </p>
                        </txt-primary>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card color="white" class="pa-20px pa-md-30px pa-lg-40px h-md-100">
                        <div class="num-wrap">
                            <u-tit-default class="tit--sm">02</u-tit-default>
                        </div>
                        <v-divider class="w-20px w-lg-30px my-18px my-lg-24px mx-auto" />
                        <txt-primary class="txt--lg text-center">
                            <p class="font-weight-extrabold grey--text text--darken-4">{{ $t("vision.num02") }}</p>
                            <p class="mt-12px mt-lg-16px">
                                <span v-html="$t('vision.num02Txt')" />
                            </p>
                        </txt-primary>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card color="white" class="pa-20px pa-md-30px pa-lg-40px h-md-100">
                        <div class="num-wrap">
                            <u-tit-default class="tit--sm">03</u-tit-default>
                        </div>
                        <v-divider class="w-20px w-lg-30px my-18px my-lg-24px mx-auto" />
                        <txt-primary class="txt--lg text-center">
                            <p class="font-weight-extrabold grey--text text--darken-4">{{ $t("vision.num03") }}</p>
                            <p class="mt-12px mt-lg-16px">
                                <span v-html="$t('vision.num03Txt')" />
                            </p>
                        </txt-primary>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card color="white" class="pa-20px pa-md-30px pa-lg-40px">
                        <div class="num-wrap">
                            <u-tit-default class="tit--sm">04</u-tit-default>
                        </div>
                        <v-divider class="w-20px w-lg-30px my-18px my-lg-24px mx-auto"></v-divider>
                        <txt-primary class="txt--lg text-center">
                            <p class="font-weight-extrabold grey--text text--darken-4">{{ $t("vision.num04") }}</p>
                            <p class="mt-12px mt-lg-16px">
                                <span v-html="$t('vision.num04Txt')" />
                            </p>
                        </txt-primary>
                    </v-card>
                </v-col>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import PageSectionSecondary from "@/sets/parents/pages/page-section-secondary.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";

import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        PageSectionSecondary,
        BtnPrimary,

        UTitWrapDefault,
        UTitDefault,
        TxtPrimary,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.page-section--vision {
    background: url("/images/sub/about/vision-bg.jpg") no-repeat center;
    background-size: cover;
}
.num-wrap {
    display: flex;
    width: 50px;
    height: 50px;
    border-radius: 50% !important;
    justify-content: center;
    align-items: center;
    background-color: var(--v-grey-lighten5);
    color: var(--v-primary-base);
    margin: auto;
}
@media (min-width: 768px) {
    .num-wrap {
        width: 60px;
        height: 60px;
    }
}
</style>
